import React from "react";
import EmailConfirmationBox from "./Common/EmailConfirmationBox";
import ServiceWorldMyCases from "./MyCases/ServiceWorldMyCases";
import CaseNeedsAttention from "./MyCases/CaseNeedsAttention";
import { getCaseLink } from "../../services/productService";
import { MinimalCase } from "../../types/Entities/MinimalCase";

const ServiceWorld = () => {
  return (
    <>
      <EmailConfirmationBox />
      <ServiceWorldMyCases
        NotificationComponent={CaseNeedsAttention}
        listItemButtonConfig={{ getLink: (minimalCase: MinimalCase) => getCaseLink(minimalCase) }}
      />
    </>
  );
};

export default ServiceWorld;
